// Sector/unit data is injected as a global `data` by the Liquid templates that
// load this script:
//   {%- assign roaster_data = shop.metafields.restaurantware.roaster_compass -%}
//   <script>var data = {{ roaster_data.value | json }};</script>
// Liquid is NOT rendered inside asset .js files, so the value cannot live here.
// Fall back to an empty object if the template did not inject it.
var data = (typeof data !== "undefined" && data) || {};

let closeSuggestions = true;

function showSuggestions(type) {
  var inputElement = document.getElementById(type + "Name");
  var suggestionsElement = document.getElementById(type + "Suggestions");
  var inputValue = inputElement.value.toLowerCase();

  var matchingData = Object.keys(data).filter((key) =>
    key.toLowerCase().includes(inputValue)
  );

  // Display suggestions for sector name
  if (type === "sector") {
    // If input is empty, show all sectors, otherwise show filtered ones
    var dataToShow = inputValue === "" ? Object.keys(data) : matchingData;
    var suggestionsHTML = dataToShow
      .map(
        (key) =>
          `<div class="dropdown-option" onclick="selectValue('${type}', '${key}')">${key}</div>`
      )
      .join("");
    suggestionsElement.innerHTML = suggestionsHTML;
  }

  // Display suggestions for unit number based on selected sector
  else if (type === "unit") {
    var selectedSector = document.getElementById("sectorName").value;
    var unitNumbers = data[selectedSector] || [];
    var matchingUnitNumbers = unitNumbers.filter((unit) =>
      unit.toLowerCase().includes(inputValue)
    );

    var suggestionsHTML = matchingUnitNumbers
      .map(
        (unit) =>
          `<div class="dropdown-option" onclick="selectValue('${type}', '${unit}')">${unit}</div>`
      )
      .join("");
    suggestionsElement.innerHTML = suggestionsHTML;
  }

  validateUnit();
}

function updateUnitSuggestions() {
  var selectedSector = document.getElementById("sectorName").value;
  var unitNumbers = data[selectedSector] || [];
  var suggestionsElement = document.getElementById("unitSuggestions");
  var suggestionsHTML = unitNumbers
    .map(
      (unit) =>
        `<div class="dropdown-option" onclick="selectValue('unit', '${unit}')">${unit}</div>`
    )
    .join("");
  suggestionsElement.innerHTML = suggestionsHTML;

  // Validate unit when sector changes
  validateUnit();
}

function selectValue(type, value) {
  document.getElementById(type + "Name").value = value;
  document.getElementById(type + "Suggestions").innerHTML = "";
  validateUnit();
}

function allowSuggestions(type) {
  closeSuggestions = false;

  document.body.addEventListener("mousedown", function (event) {
    if (
      closeSuggestions &&
      event.target.id !== type + "Name" &&
      !event.target.classList.contains("dropdown-option")
    ) {
      document.getElementById(type + "Suggestions").innerHTML = "";
    }
    closeSuggestions = true;
  });
}

function handleDropdownClick(type) {
  closeSuggestions = false;
}

function validateUnit() {
  const unitInput = document.getElementById("unitName");
  const selectedSector = document.getElementById("sectorName").value.trim();
  const enteredUnit = unitInput.value.trim();
  const copyIcon = document.querySelectorAll(".copy-icon");

  if (
    selectedSector &&
    data[selectedSector] &&
    data[selectedSector].includes(enteredUnit)
  ) {
    unitInput.classList.remove("invalid-unit");
    unitInput.classList.add("valid-unit");
    copyIcon.forEach((icon) => (icon.style.display = "block"));
  } else {
    unitInput.classList.remove("valid-unit");
    unitInput.classList.add("invalid-unit");
    copyIcon.forEach((icon) => (icon.style.display = "none"));
  }
}

function copyToClipboard(inputId) {
  const input = document.getElementById(inputId);
  input.select();
  document.execCommand("copy");
}

// Removing unit number if sector is changing
function clearSecondInput() {
  document.getElementById("unitName").value = "";
}
function updateUnitSuggestions() {
  clearSecondInput();
  const selectedSector = document.getElementById("sectorName").value;
  const unitNumbers = data[selectedSector] || [];
  const suggestionsElement = document.getElementById("unitSuggestions");
  suggestionsElement.innerHTML = unitNumbers
    .map(
      (unit) =>
        `<div class="dropdown-option" onclick="selectValue('unit', '${unit}')">${unit}</div>`
    )
    .join("");

  validateUnit();
}
document
  .getElementById("sectorName")
  .addEventListener("input", updateUnitSuggestions);

//   unit number scroll through mouse
document
  .getElementById("unitSuggestions")
  .addEventListener("mousedown", function (event) {
    event.stopPropagation();
  });

// Add focus event listeners to show suggestions when input is focused
document.addEventListener("DOMContentLoaded", function() {
  const sectorInput = document.getElementById("sectorName");
  const unitInput = document.getElementById("unitName");

  if (sectorInput) {
    sectorInput.addEventListener("focus", function() {
      // Show suggestions even if input is empty
      showSuggestions('sector');
    });

    sectorInput.addEventListener("click", function() {
      // Show suggestions even if input is empty
      showSuggestions('sector');
    });
  }

  if (unitInput) {
    unitInput.addEventListener("focus", function() {
      const selectedSector = document.getElementById("sectorName").value;
      if (selectedSector && data[selectedSector]) {
        updateUnitSuggestions();
      }
    });

    unitInput.addEventListener("click", function() {
      const selectedSector = document.getElementById("sectorName").value;
      if (selectedSector && data[selectedSector]) {
        updateUnitSuggestions();
      }
    });
  }
});
